// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"839c532f","588":"810c9fb1"}[chunkId] + ".css";
};